<!--
     <ProcessDependingUserField
       :props="my_attrs_dictionary"
       @bind="my_bind_handler"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - id [REQUIRED] → This instance id.
     - process_field_id [REQUIRED] → The id of a process select to watch
     - permission_id [REQUIRED] → The permission_id, like "NCDEFAULT.evaluador"
     - multiple (default: false)
     - value
     - label
     - placeholder
-->

<template>
  <component
    v-bind:is="props.subcomponent"
    :ref="props.id"
    :id="props.id"
    :props="props.subcomponent_attributes"
    @update="update"
    ></component>
</template>


<script>
import { mapGetters } from 'vuex'
import QUnitWidgets from '@/api/QUnitWidgets'

import TextInput from '@/components/inputs/TextInput'
import DateInput from '@/components/inputs/DateInput'
import TextareaInput from '@/components/inputs/TextareaInput'
import NumericInput from '@/components/inputs/NumericInput'
import DateTimeInput from '@/components/inputs/DateTimeInput'


export default {
  components: {
    TextInput,
    DateInput,
    TextareaInput,
    NumericInput,
    DateTimeInput
  },
  name: 'DynamicInput',

  props: ['props','form_values','current_unit'],

  data: () => ({
    loading: false,
    root_field_id: '',
  }),

  computed: {
    ...mapGetters(['sitePath']),

    value() {
      //   return this.props.value
      return this.$refs[this.props.id].value // || null
    },
    
    // rules() {
    //   // TODO: Multilang: Change hardcoded string
    //   return [(value) => !!value || !this.props.required || 'Campo requerido']
    // },
    root_field_value() {
      return this.form_values[this.props.root_field_id];
    },
  },

  mounted() {
    // this.value = this.props.value || null
  },

  methods: {
    validate() {
      // TODO: Show error message
      return !this.props.required || !!this.$refs[this.props.id].validate && !this.$refs[this.props.id].validate()
    },

    update_items(value) {
      if (value===null || value===undefined) {
        this.update(null);
        return;
      }

      this.loading = true
      // Updates values because reference value has changed
      QUnitWidgets.get_depending_input_value(this.sitePath, {
        reference_value: value,
        bp_reference: this.props.bp_reference,
        site_id: this.props.site_id,
        field_id: this.props.id,
        current_qunit_id: this.current_unit ? this.current_unit.uid : "",
      })
        .then(
          function (data) {
            this.loading = false;
            // this.props.subcomponent_attributes.value = data.data;
            this.update(data.data);
          }.bind(this),
        )
        .catch((err) => console.warn(err)) // DEBUG
    },

    error_state(ok) {
      this.valid = ok
    },

    update(value) {
      this.props.subcomponent_attributes.value = value;
      this.$emit('update',value);
    },
  },
  watch: {
    root_field_value(a,b) {
      if (a === b) {
         return;
      }
      this.update_items(this.root_field_value);
    }
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>
